import { render, staticRenderFns } from "./ChangePassModal.vue?vue&type=template&id=0334bfa8&scoped=true"
import script from "./ChangePassModal.vue?vue&type=script&lang=js"
export * from "./ChangePassModal.vue?vue&type=script&lang=js"
import style0 from "./ChangePassModal.vue?vue&type=style&index=0&id=0334bfa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0334bfa8",
  null
  
)

export default component.exports